import { getMeta } from '@/helpers/metaHelpers'

export default {
  metaInfo() {
    if (this.$page) {
      return getMeta(this.$page.seo)
    }
  }
}
